import { c as _c } from "react/compiler-runtime";
import NFTImage from "@/components/nft-image/NFTImage";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
interface NowMintingArtworkProps {
  readonly nft: NFTWithMemesExtendedData;
}
export default function NowMintingArtwork(t0) {
  const $ = _c(2);
  const {
    nft
  } = t0;
  let t1;
  if ($[0] !== nft) {
    t1 = <div className="tw-flex tw-w-full tw-items-start tw-justify-center"><NFTImage nft={nft} animation={true} height={650} showBalance={true} /></div>;
    $[0] = nft;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}